import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { STATIC_ROOT } from '../../constants';

import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import { mobile } from '../../scss/_variables.scss';

const LogoWrapper = styled.div`
    display: flex;
    align-items: center;

    @media screen and (max-width: ${mobile}) {
        .isvg,
        img {
            max-height: 30px;
            width: auto;
        }
    }
`;

const mapStateToProps = state => ({
    LOGO_TEXT: state.i18n.feature.header.LOGO_TEXT,
    COMPANY_NAME: state.i18n.common.COMPANY_NAME
});
export const Logo = connect(mapStateToProps)(({ className, LOGO_TEXT, COMPANY_NAME }) => (
    <LogoWrapper>
        <div className={className}>
            <img src={`${STATIC_ROOT}/logo.png`} alt={COMPANY_NAME} width="200" height="43" />
        </div>
        <span>{convertHtmlToReactDomWithParams(LOGO_TEXT)}</span>
    </LogoWrapper>
));

export default connect(mapStateToProps)(Logo);



// WEBPACK FOOTER //
// ./src/components/icons/Logo.js